function stickyHeader(el) {
    window.addEventListener('scroll', function() {
        el.classList.toggle('header--small', window.scrollY > 0);
    });
}

export default stickyHeader;